import "./ThankYouTemplate.scss";
import { IconArrowMedium } from "../icons/svgs";
import ThankYouPreview from "../preview/ThankYouPreview";
import NextAction from "../actions/NextAction";
class ThankYouTemplate {
    structures() {
        return {
            title: {
                type: 'text',
                label: 'Title',
                placeholder: 'Greeting Title',
            },
            description: {
                label: 'Description',
                type: 'tinymce',
                placeholder: 'Description max 600 characters',
                rules: {
                    maxChar: 600, // 320 characters
                }
            }
        }

    }

    type() {
        return 'ThankYouTemplate';
    }
    name() {
        return 'Ending Slide';
    }
    iconType() {
        return this.structures().title.type;
    }
    canRearrange() {
        return false;
    }
    canRenameLabel() {
        return false;
    }
    render(data, index, inEditor) {
        return (
            <ThankYouPreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }
    getDuration() {
        return 60;
    }
    actions(data, index) {
        return (
            <NextAction label='Next Lesson' icon={<IconArrowMedium />} />
        );
    }
}

export default ThankYouTemplate;
